import { parseToItemsWithKeys } from 'utils/parseToItems';

import useTranslation from 'components/fields/BoundarySelectPanelField/hooks/useTranslation';

import useBoundaries from 'hooks/useBoundaries';
import useSelectPanelField from 'hooks/useSelectPanelField';

import { DEFAULT_PAGE_SIZE } from './constants';
import type { BoundaryResponse, Props } from './types';

const useData = ({ siteId }: Props) => {
    const { fetch, isLoading, reset } = useBoundaries();
    const { NO_BOUNDARIES_FOUND } = useTranslation();

    const fetchWithSiteId = (args?: { name?: string; pageSize?: number }) =>
        fetch({
            includeUnassigned: true,
            name: args?.name,
            pageSize: args?.pageSize,
            siteId
        });

    const { handleAsyncFilter, hasNextPage, items, noItemsText, onNextPage } =
        useSelectPanelField<BoundaryResponse>({
            dependency: siteId,
            fetchFn: fetchWithSiteId,
            noItemsFoundText: NO_BOUNDARIES_FOUND,
            pageSize: DEFAULT_PAGE_SIZE,
            parseFn: boundaries => parseToItemsWithKeys(boundaries, ['siteId']),
            resetFn: reset
        });

    return {
        boundaryItems: items,
        handleAsyncFilter,
        hasNextPage,
        isLoading,
        noItemsText,
        onNextPage
    };
};

export default useData;
